import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import CustomMessageDialog from "./CustomMessageDialog";
import backtomapButton from "../../../assets/loan-interactive/back-to-map_default-button.png";
import ProgressContext from "../../../utils/context";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function Vendor4({ handleChildHideCloseUp, objData, lang }) {
  const { updateProgress } = useContext(ProgressContext);
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });

  useEffect(() => {
    return () => {
      updateProgress(0);
    };
  }, []);
  return (
    <div
      style={{
        position: md ? "absolute" : "inherit",
        width: "100%",
        height: "100%",
        paddingTop: "1rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FFFFFF40",
          height: "80%",
          padding: "1.5rem",
          borderRadius: "1rem",
          width: "70%",
          marginLeft: "15%",
        }}
      >
        <CustomMessageDialog
          pageLang={lang}
          objData={objData}
          mainContainer={{
            height: md ? "inherit" : "400px",
            flexGrow: "1",
          }}
        />
      </Box>
      <Box sx={{}}>
        {lang === "en" ? (
          <img
            onClick={() => handleChildHideCloseUp("fourShow")}
            src={backtomapButton}
            alt="backtomapButton"
            style={{
              cursor: "pointer",
              marginTop: "1rem",
              marginLeft: "15%",
              height: "4rem",
            }}
          />
        ) : (
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => handleChildHideCloseUp("fourShow")}
            sx={{
              marginTop: "1rem",
              marginLeft: "15%",
              height: "4rem",
              backgroundColor: "#ffffff",
              color: "black",
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: "2rem",
              padding: "1rem",
              fontSize: "1.05rem",
              "&:hover": {
                backgroundColor: "#ffffff",
                color: "black",
              },
            }}
          >
            Bumalik sa Mapa
          </Button>
        )}
      </Box>
    </div>
  );
}

export default Vendor4;
